import { useQuery } from 'urql';

import { useGetLoggedInUser } from '@revelio/auth';
import { GetClientDetailsDocument } from '@revelio/data-access';

export type TaxonomyAllowlist = {
  role: number[];
  skill: number[];
};

/**
 * Per-client-group allowlist of custom taxonomy IDs (role and skill).
 * `default` applies when the user's client group is missing from this map.
 * To roll out a new taxonomy to a subset of clients, add their
 * `client_group` key here — do not change `default`.
 */
export const CUSTOM_TAXONOMIES_BY_CLIENT_GROUP: Record<
  string,
  TaxonomyAllowlist
> & { default: TaxonomyAllowlist } = {
  default: { role: [61, 62, 63], skill: [] },
  'Aviva Taxonomy Project': { role: [61, 62, 63], skill: [65] },
};

export const useCustomTaxonomyAllowlist = (): TaxonomyAllowlist => {
  const { loggedInUser } = useGetLoggedInUser();
  const [{ data }] = useQuery({
    query: GetClientDetailsDocument,
    variables: { ids: [loggedInUser?.client_name as string] },
    pause: !loggedInUser?.client_name,
  });
  const clientGroup =
    data?.clients?.[0]?.data_builder_configuration?.client_group ?? '';
  return (
    CUSTOM_TAXONOMIES_BY_CLIENT_GROUP[clientGroup] ??
    CUSTOM_TAXONOMIES_BY_CLIENT_GROUP.default
  );
};
